<script>

    import View from '../$layouts/view.layout.svelte'

    import ModalContainer from '../$components/modal.container.svelte'

    import TicketsComponent from './component.tickets.svelte'
    import TicketComponent from './component.ticket.svelte'
    import TicketUpdateComponent from './component.update.svelte'

    import TitleHero from '../$components/title.hero.svelte'

</script>

<View>
    <div>
        <TitleHero title="Tickets" subtitle="Consulta y gestión de tickets" />
        <TicketsComponent />
    </div>
</View>

<ModalContainer id="ticket_modal" title="Detalle del ticket">
    <TicketComponent />
</ModalContainer>

<ModalContainer id="ticket_update_modal" title="Actualizar ticket">
    <TicketUpdateComponent />
</ModalContainer>
